<template>
  <v-container>
    <v-form :lazy-validation="true">
      <validation-observer ref="validationObserver" v-slot="{ invalid }">
        <v-row class="hidden-lg-and-up mb-n6">
          <v-col>
            <v-select
              :label="$t('form.fields.salutation.label')"
              outlined
              v-model="user.attributes.salutation"
              :items="genderTypes"
              v-if="isSupporter"
            ></v-select>
            <validation-provider
              :name="$t('form.fields.salutation.label')"
              v-slot="{ errors }"
              rules="required"
              v-else
            >
              <v-select
                :label="$t('form.fields.salutation.label') + ' *'"
                outlined
                v-model="user.attributes.salutation"
                :items="genderTypes"
                :error-messages="errors"
              ></v-select>
            </validation-provider>
          </v-col>
          <v-col>
            <v-text-field
              outlined
              v-model="user.attributes.title"
              :label="$t('form.fields.title')"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row class="mb-2">
          <v-col cols="2" class="hidden-md-and-down">
            <v-select
              :label="$t('form.fields.salutation.label')"
              outlined
              v-model="user.attributes.salutation"
              :items="genderTypes"
              v-if="isSupporter"
            ></v-select>
            <validation-provider
              :name="$t('form.fields.salutation.label')"
              v-slot="{ errors }"
              rules="required"
              v-else
            >
              <v-select
                :label="$t('form.fields.salutation.label') + ' *'"
                outlined
                v-model="user.attributes.salutation"
                :items="genderTypes"
                :error-messages="errors"
              ></v-select>
            </validation-provider>
          </v-col>
          <v-col>
            <v-text-field
              :label="$t('form.fields.firstname')"
              outlined
              v-model="user.firstName"
              v-if="isSupporter"
            ></v-text-field>
            <validation-provider
              :name="$t('form.fields.firstname')"
              v-slot="{ errors }"
              rules="required"
              v-else
            >
              <v-text-field
                :label="$t('form.fields.firstname') + ' *'"
                outlined
                v-model="user.firstName"
                :error-messages="errors"
              ></v-text-field>
            </validation-provider>
          </v-col>
          <v-col>
            <v-text-field
              :label="$t('form.fields.lastname')"
              outlined
              v-model="user.lastName"
              v-if="isSupporter"
            ></v-text-field>
            <validation-provider
              :name="$t('form.fields.lastname')"
              v-slot="{ errors }"
              rules="required"
              v-else
            >
              <v-text-field
                :label="$t('form.fields.lastname') + ' *'"
                outlined
                v-model="user.lastName"
                :error-messages="errors"
              ></v-text-field>
            </validation-provider>
          </v-col>
          <v-col cols="2" class="hidden-md-and-down">
            <v-text-field
              outlined
              v-model="user.attributes.title"
              :label="$t('form.fields.title')"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row class="mt-n8 mb-2">
          <v-col cols="6">
            <validation-provider
              :name="$t('form.fields.email')"
              v-slot="{ errors }"
              vid="originalEmail"
              rules="required|email|confirmed:@confirmationEmail"
            >
              <v-text-field
                ref="originalMail"
                v-model="user.email"
                :label="$t('form.fields.email') + ' *'"
                required
                outlined
                :error-messages="errors"
              >
              </v-text-field>
            </validation-provider>
          </v-col>
          <v-col cols="6">
            <validation-provider
              :name="$t('form.fields.emailConfirmation')"
              v-slot="{ errors }"
              vid="confirmationEmail"
              rules="required|email|confirmed:@originalEmail"
            >
              <v-text-field
                v-model="confirmationEmail"
                :label="$t('form.fields.emailConfirmation') + ' *'"
                required
                outlined
                :error-messages="errors"
              >
              </v-text-field>
            </validation-provider>
          </v-col>
        </v-row>
        <v-row class="mt-n8 mb-2">
          <v-col>
            <v-menu
              v-model="showBirthdate"
              :close-on-content-click="false"
              max-width="290"
              rounded="xl"
            >
              <template #activator="{ on, attrs }">
                <validation-provider
                  :name="$t('form.fields.birthdate')"
                  v-slot="{ errors }"
                  rules="required"
                >
                  <v-text-field
                    :label="$t('form.fields.birthdate') + ' *'"
                    :value="
                      $options.filters.formatDate(user.attributes.birthdate)
                    "
                    v-bind="attrs"
                    v-on="on"
                    append-icon="mdi-calendar"
                    :error-messages="errors"
                    outlined
                  />
                </validation-provider>
              </template>
              <v-date-picker
                v-model="user.attributes.birthdate"
                @change="showBirthdate = false"
                locale="de"
                first-day-of-week="1"
              />
            </v-menu>
          </v-col>
          <v-col>
            <validation-provider
              :name="$t('form.fields.societySections')"
              v-slot="{ errors }"
              rules="required|societySectionsRequired"
            >
              <v-combobox
                v-model="user.attributes.societySections"
                :items="[1, 2, 3, 4, 5]"
                :label="$t('form.fields.societySections') + ' *'"
                multiple
                outlined
                :error-messages="errors"
                @change="checkForYoungMember"
              >
                <template v-slot:item="{ item, attrs }">
                  <v-checkbox
                    v-model="attrs.inputValue"
                    :label="$t(`societySection.${item}`)"
                    color="primary"
                    :disabled="
                      user.attributes.memberType === 'YM' && item === 5
                    "
                  ></v-checkbox>
                </template>
                <template v-slot:selection="{ attrs, item, selected }">
                  <v-chip
                    v-bind="attrs"
                    :input-value="selected"
                    :close="user.attributes.memberType !== 'YM' || item !== 5"
                    @click:close="removeSocietySection(item)"
                  >
                    {{ $t(`societySection.${item}`) }}
                  </v-chip>
                </template>
              </v-combobox>
            </validation-provider>
          </v-col>
          <v-col>
            <validation-provider
              :name="$t('form.fields.memberType')"
              v-slot="{ errors }"
              rules="required"
            >
              <v-select
                :label="$t('form.fields.memberType') + ' *'"
                outlined
                v-model="user.attributes.memberType"
                :items="memberTypes"
                :error-messages="errors"
                @change="checkForYoungMember"
              ></v-select>
            </validation-provider>
          </v-col>
        </v-row>
        <v-row class="mt-n8 mb-2" v-if="isStudent">
          <v-col>
            <validation-provider
              :name="$t('form.fields.certificateOfStudy')"
              v-slot="{ errors }"
              rules="required"
            >
              <v-file-input
                :label="$t('form.fields.certificateOfStudy') + ' *'"
                outlined
                :error-messages="errors"
                v-model="certificateOfStudy"
                :loading="submitting"
              ></v-file-input>
            </validation-provider>
          </v-col>
        </v-row>
        <v-row class="mt-n8 mb-2" v-if="!isSupporter">
          <v-col>
            <v-switch
              v-model="user.attributes.hasCompanyAddress"
              :label="$t('form.fields.companyAddress')"
            ></v-switch>
          </v-col>
        </v-row>
        <v-row
          class="mt-n8 mb-2"
          v-if="user.attributes.hasCompanyAddress || isSupporter"
        >
          <v-col>
            <validation-provider
              :name="$t('form.fields.company')"
              v-slot="{ errors }"
              rules="required"
            >
              <v-text-field
                :label="$t('form.fields.company') + ' *'"
                outlined
                v-model="user.attributes.company"
                :error-messages="errors"
              ></v-text-field>
            </validation-provider>
          </v-col>
          <v-col>
            <v-text-field
              :label="$t('form.fields.department')"
              outlined
              v-model="user.attributes.department"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row
          class="mt-n8 mb-2"
          v-if="user.attributes.hasCompanyAddress || isSupporter"
        >
          <v-col>
            <v-text-field
              :label="$t('form.fields.companyAddition')"
              outlined
              v-model="user.attributes.companyAddition"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row class="mt-n8 mb-2">
          <v-col>
            <validation-provider
              :name="$t('form.fields.street')"
              v-slot="{ errors }"
              rules="required"
            >
              <v-text-field
                :label="$t('form.fields.street') + ' *'"
                outlined
                v-model="user.attributes.street"
                :error-messages="errors"
              ></v-text-field>
            </validation-provider>
          </v-col>
          <v-col cols="2">
            <validation-provider
              :name="$t('form.fields.zip')"
              v-slot="{ errors }"
              rules="required"
            >
              <v-text-field
                :label="$t('form.fields.zip') + ' *'"
                outlined
                v-model="user.attributes.zip"
                :error-messages="errors"
              ></v-text-field>
            </validation-provider>
          </v-col>
          <v-col cols="3">
            <validation-provider
              :name="$t('form.fields.city')"
              v-slot="{ errors }"
              rules="required"
            >
              <v-text-field
                :label="$t('form.fields.city') + ' *'"
                outlined
                v-model="user.attributes.city"
                :error-messages="errors"
              ></v-text-field>
            </validation-provider>
          </v-col>
        </v-row>
        <v-row class="mt-n8 mb-2">
          <v-col cols="6">
            <validation-provider
              :name="$t('form.fields.country')"
              v-slot="{ errors }"
              rules="required"
            >
              <v-autocomplete
                :label="$t('form.fields.country') + ' *'"
                outlined
                :items="countries"
                v-model="user.attributes.country"
                item-text="value"
                item-value="key"
                :error-messages="errors"
              >
              </v-autocomplete>
            </validation-provider>
          </v-col>
          <v-col>
            <v-text-field
              label="UID"
              outlined
              v-model="user.attributes.uid"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row class="mt-n8 mb-2">
          <v-col cols="6">
            <v-text-field
              :label="$t('form.fields.phone')"
              outlined
              v-model="user.attributes.telephone"
              type="tel"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              :label="$t('form.fields.mobilePhone')"
              outlined
              v-model="user.attributes.cellphone"
              type="tel"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row class="mt-n8 mb-2">
          <v-col>
            <v-switch
              v-model="user.attributes.hasInvoiceAddress"
              :label="$t('form.fields.differentInvoiceAddress')"
            ></v-switch>
          </v-col>
        </v-row>
        <v-expansion-panels
          :disabled="!user.attributes.hasInvoiceAddress"
          :value="user.attributes.hasInvoiceAddress ? 0 : null"
          class="mt-n8 mb-2"
        >
          <v-expansion-panel>
            <v-expansion-panel-header>
              {{ $t("form.fields.invoiceAddress") }}
            </v-expansion-panel-header>
            <v-expansion-panel-content v-if="user.attributes.hasInvoiceAddress">
              <v-row class="hidden-lg-and-up mb-n6">
                <v-col>
                  <v-select
                    :label="$t('form.fields.salutation.label')"
                    outlined
                    v-model="user.attributes.invoiceSalutation"
                    :items="genderTypes"
                  ></v-select>
                </v-col>
                <v-col>
                  <v-text-field
                    outlined
                    v-model="user.attributes.invoiceTitle"
                    :label="$t('form.fields.title')"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row class="mb-2">
                <v-col cols="2" class="hidden-md-and-down">
                  <v-select
                    :label="$t('form.fields.salutation.label')"
                    outlined
                    v-model="user.attributes.invoiceSalutation"
                    :items="genderTypes"
                  ></v-select>
                </v-col>
                <v-col>
                  <v-text-field
                    :label="$t('form.fields.firstname')"
                    outlined
                    v-model="user.attributes.invoiceFirstName"
                  ></v-text-field>
                </v-col>
                <v-col>
                  <v-text-field
                    :label="$t('form.fields.lastname')"
                    outlined
                    v-model="user.attributes.invoiceLastName"
                  ></v-text-field>
                </v-col>
                <v-col cols="2" class="hidden-md-and-down">
                  <v-text-field
                    outlined
                    v-model="user.attributes.invoiceTitle"
                    :label="$t('form.fields.title')"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row class="mt-n8 mb-2">
                <v-col>
                  <validation-provider
                    :name="$t('form.fields.street')"
                    v-slot="{ errors }"
                    rules="required"
                  >
                    <v-text-field
                      :label="$t('form.fields.street') + ' *'"
                      outlined
                      v-model="user.attributes.invoiceStreet"
                      :error-messages="errors"
                    ></v-text-field>
                  </validation-provider>
                </v-col>
                <v-col cols="2">
                  <validation-provider
                    :name="$t('form.fields.zip')"
                    v-slot="{ errors }"
                    rules="required"
                  >
                    <v-text-field
                      :label="$t('form.fields.zip') + ' *'"
                      outlined
                      v-model="user.attributes.invoiceZip"
                      :error-messages="errors"
                    ></v-text-field>
                  </validation-provider>
                </v-col>
                <v-col cols="3">
                  <validation-provider
                    :name="$t('form.fields.city')"
                    v-slot="{ errors }"
                    rules="required"
                  >
                    <v-text-field
                      :label="$t('form.fields.city') + ' *'"
                      outlined
                      v-model="user.attributes.invoiceCity"
                      :error-messages="errors"
                    ></v-text-field>
                  </validation-provider>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="mt-n8 mb-2">
                  <validation-provider
                    :name="$t('form.fields.country')"
                    v-slot="{ errors }"
                    rules="required"
                  >
                    <v-autocomplete
                      :label="$t('form.fields.country') + ' *'"
                      outlined
                      :items="countries"
                      v-model="user.attributes.invoiceCountry"
                      item-text="value"
                      item-value="key"
                      :error-messages="errors"
                    >
                    </v-autocomplete>
                  </validation-provider>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <v-row class="ml-0 mb-6">
          <v-checkbox outlined v-model="agb">
            <template v-slot:label>
              <span v-html="$t('form.fields.agbsAndStatutes') + ' *'"></span>
            </template>
          </v-checkbox>
        </v-row>
        <v-row class="my-n12" v-if="!didVerify">
          <v-col>
            <div id="mcaptcha__widget-container" />
          </v-col>
        </v-row>
        <v-row class="mb-n8" v-if="errorMessage">
          <v-col>
            <v-alert dense outlined type="error">
              {{ errorMessage }}
            </v-alert>
          </v-col>
        </v-row>
        <v-card-actions class="mt-3 mb-n5">
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            :disabled="invalid || !agb"
            @click="submit"
            :loading="submitting"
          >
            {{ $t("form.btn.register") }}
          </v-btn>
        </v-card-actions>
      </validation-observer>
    </v-form>
    <v-dialog v-model="dialog" width="500">
      <v-card>
        <v-card-title class="white--text headline primary" primary-title>
          {{ $t("confirmationDialog.title") }}
        </v-card-title>
        <v-card-text class="pa-md-4">
          {{ $t("confirmationDialog.confirmationText") }}
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="reload">
            {{ $t("confirmationDialog.buttonText") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import {
  GenderTypes,
  SocietySections,
  UserMemberTypes,
} from "../config/constants";
import {
  verificationResource,
  mcaptchaSettingsResource,
  attachmentResource,
  registerUserResource,
} from "../api/resources";
import de from "../i18n/de.json";
import en from "../i18n/en.json";
import { extend } from "vee-validate";
import * as moment from "moment";

extend("societySectionsRequired", {
  message: () =>
    (window.location.pathname.startsWith("/en") ? en : de)
      .validationYoungMembers,
  validate: (value) => {
    if (value.includes(5) && value.length < 2) {
      return false;
    }
    return true;
  },
});

export default {
  data: () => ({
    user: {
      attributes: {
        hasCompanyAddress: false,
        hasInvoiceAddress: false,
        /*     salutation: "mr",
        memberType: "A",
        street: "fff",
        zip: "444",
        city: "4444",
        country: "DE",*/
      },
      /*firstName: "test",
      lastName: "test",
      email: "test@example.com",*/
    },
    certificateOfStudy: null,
    confirmationEmail: null,
    errorMessage: null,
    dialog: false,
    agb: false,
    submitting: false,
    showBirthdate: false,
    didVerify: false,
  }),
  async mounted() {
    const captchaSettings = (await mcaptchaSettingsResource.get()).data;
    let config = {
      widgetLink: new URL(captchaSettings.widgetLink),
    };
    // eslint-disable-next-line no-undef
    new mcaptchaGlue.default(config);
  },
  methods: {
    checkForYoungMember() {
      const societySections = this.user.attributes.societySections || [];
      if (
        this.user.attributes.memberType === "YM" &&
        !societySections.includes(5)
      ) {
        societySections.push(5);
        this.user.attributes.societySections = societySections;
      }
    },

    async submit() {
      this.errorMessage = null;

      if (
        this.user.attributes.societySections.includes(5) &&
        moment().diff(this.user.attributes.birthdate, "years") >= 36
      ) {
        this.errorMessage = this.$t("validationYoungMembersBirthdate");
        this.user.attributes.birthdate = "";
        return;
      }
      if (!this.didVerify) {
        const verificationToken =
          document.getElementById("mcaptcha__token").value;
        if (!verificationToken) {
          return;
        }
        await verificationResource.post("", {
          token: verificationToken,
        });
      }
      this.didVerify = true;
      this.submitting = true;
      if (this.isStudent) {
        let formData = new FormData();
        formData.append("file", this.certificateOfStudy);
        const data = await attachmentResource.post("", formData, {
          headers: { "x-xsrf-token": this.$cookies.get("oegg-cms.csrf") },
        });
        this.user.attributes.certificateOfStudyAttachmentId = data.data._id;
      }
      await registerUserResource.post("", this.user).catch(() => {
        this.errorMessage = this.$t("error.mailExists", {
          mail: this.user.email,
        });
      });
      this.submitting = false;
      if (this.errorMessage) {
        return;
      }
      this.user = {
        attributes: { hasCompanyAddress: false, hasInvoiceAddress: false },
      };
      this.certificateOfStudy = null;
      this.confirmationEmail = null;
      this.agb = false;
      this.$refs.validationObserver.reset();
      this.dialog = true;
    },
    removeSocietySection(item) {
      this.user.attributes.societySections.splice(
        this.user.attributes.societySections.indexOf(item),
        1
      );
    },
    reload() {
      location.reload();
    },
  },
  computed: {
    societySections() {
      return SocietySections.map((t) => {
        return { value: "" + t, text: this.$t(`societySection.${t}`) };
      });
    },
    genderTypes() {
      return GenderTypes.map((t) => {
        return { value: t, text: this.$t(`form.fields.salutation.${t}`) };
      });
    },
    memberTypes() {
      return UserMemberTypes.map((t) => {
        return { value: t, text: this.$t(`form.memberType.${t}`) };
      });
    },
    allGroupValues() {
      return this.allGroups.map((group) => ({
        value: group,
        text: this.$t(`groups.${group}`),
      }));
    },
    userGroupValues() {
      return this.userGroups.map((group) => ({
        value: group,
        text: this.$t(`groups.${group}`),
      }));
    },
    countries() {
      return Object.keys(de.countries).map((countryKey) => {
        return {
          key: countryKey,
          value: this.$t(`countries.${countryKey}`),
        };
      });
    },
    isStudent() {
      return (
        this.user.attributes.memberType === "As" ||
        this.user.attributes.memberType === "Is"
      );
    },
    isSupporter() {
      return this.user.attributes.memberType === "F";
    },
  },
};
</script>
